import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Observable } from "rxjs";
import { LearnerLearningRecord } from "../_models/LearnerLearningRecord";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class WrittenAssignmentService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "WrittenAssignment/";
  private static readonly GET_WRITTENASSIGNMENTRECORDS: string = "learningrecord/records/";
  private static readonly VIEW_WRITTENASSIGNMENTRECORDS: string = "learningrecord/records/view/";

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public getWrittenAssignmentRecords$(courseId: number): Observable<LearnerLearningRecord[]> {
    return this.http.get<LearnerLearningRecord[]>(`${this.baseUrl}${WrittenAssignmentService.path}${WrittenAssignmentService.GET_WRITTENASSIGNMENTRECORDS}${courseId}`);
  }

  public viewWrittenAssignmentRecords$(courseId: number, learnerId: number): Observable<LearnerLearningRecord[]> {
    return this.http.get<LearnerLearningRecord[]>(`${this.baseUrl}${WrittenAssignmentService.path}${WrittenAssignmentService.VIEW_WRITTENASSIGNMENTRECORDS}${courseId}${AppConstants.SLASH}${learnerId}`);
  }
}
